import { transparentize } from 'polished'

const theme = {
  font: 'exo2',
  colors: {
    palette: {
      background: '#fff5e3',  // sazerac
      primary: '#ff883e',  // crusta
      secondary: '#ff6638',  // outrageous orange
      shade: '#d7e1e1',  // geyser
    },
    get link() {
      const link = this.palette.primary

      return {
        regular: transparentize(0.4, link),
        hover: transparentize(0.6, link),
      }
    },
    codeblock: {
      background: '#eee',
      color: 'dimgray',
      copyButton: {
        background: '#ddd',
        color: '#333',
        hoverBackground: '#ccc',
      },
    },
  },
  screens: {
    // large: '1200px',
    // medium: '990px',
    small: '480px',
  },
}

export default theme
